import { Directive } from '@angular/core';

@Directive({
  selector: '[nzDateCell]'
})
export class NzDateCellDirective {}

@Directive({
  selector: '[nzMonthCell]'
})
export class NzMonthCellDirective {}

@Directive({
  selector: '[nzDateFullCell]'
})
export class NzDateFullCellDirective {}

@Directive({
  selector: '[nzMonthFullCell]'
})
export class NzMonthFullCellDirective {}
